export default "__VITE_ASSET__Cx4qBvNd__"